module.exports = __webpack_public_path__ + "static/media/msrating_106.b16e0fc3.ico";